import React, { useState } from 'react';
import { DollarSign } from 'lucide-react';
import { Input } from '@/components/ui/input';
import SaleToggle from './SaleToggle';

// Inline Price Editor Component
const InlinePriceEditor = ({ product, onUpdate }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [price, setPrice] = useState(product.price);
  const [salePrice, setSalePrice] = useState(product.sale_price);

  const handlePriceBlur = () => {
    if (price !== product.price) {
      onUpdate({ price: parseFloat(price) || product.price, sale_price: salePrice });
    }
    setIsEditing(false);
  };

  const handleSaleChange = (newSalePrice) => {
    setSalePrice(newSalePrice);
    onUpdate({ price, sale_price: newSalePrice });
  };

  return (
    <div className="flex items-center gap-3 flex-wrap">
      <div className="flex items-center gap-1">
        <DollarSign className="w-4 h-4 text-muted-foreground" />
        {isEditing ? (
          <Input
            type="number"
            step="0.01"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
            onBlur={handlePriceBlur}
            onKeyDown={(e) => e.key === 'Enter' && handlePriceBlur()}
            className="w-20 h-7 text-sm"
            autoFocus
          />
        ) : (
          <button
            onClick={() => setIsEditing(true)}
            className="text-sm font-semibold hover:bg-secondary px-2 py-0.5 rounded transition-colors"
          >
            {parseFloat(price).toFixed(2)}
          </button>
        )}
      </div>
      <SaleToggle 
        price={parseFloat(price)} 
        salePrice={salePrice} 
        onSaleChange={handleSaleChange}
        compact={true}
      />
    </div>
  );
};

export default InlinePriceEditor;
